export default __webpack_public_path__ + "fonts/inter-latin-200-normal.804145072b69cd920cda.woff";